import React, { Fragment, useEffect, useState, useRef } from "react"
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import { useReactToPrint } from 'react-to-print'
import Select from 'react-select'
import XLSX from 'xlsx'

import { TOGGLE_LEFT_MENU } from 'store/layout/actions'
import { httpOk, GET } from 'helpers/api'
import { formatDate, formatMoney, returnSign } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const date = new Date()

	const printRef = useRef();

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [cheques, setCheques] = useState([])
	const [suppliers, setSuppliers] = useState([])
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [modalCheques, setModalCheques] = useState(false)
	const [filterData, setFilterData] = useState({
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		ids: []
	})

	async function searchWithFilter(filterDataCopy) {
		var filterUrl = "/chain/element-incomes"
		var urlParams = ""

		if (filterDataCopy.ids)
			urlParams += returnSign(urlParams) + 'ids=' + filterDataCopy.ids
		if (filterDataCopy.supplier_id)
			urlParams += returnSign(urlParams) + 'supplier_id=' + filterDataCopy.supplier_id
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date

		filterUrl = filterUrl + urlParams
		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setDropdownIsOpen(false)
			setData(response.data)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handleCheckboxChangeAll(e) {
		var filterDataCopy = { ...filterData }

		filterDataCopy.ids = []
		if (e.target.checked) {
			for (let i = 0; i < poses.length; i++) {
				filterDataCopy.ids.push(poses[i]['id'])
			}
		}

		setFilterData(filterDataCopy)
	}

	function handleCheckboxChange(e, id) {
		var filterDataCopy = { ...filterData }

		if (e.target.checked) {
			filterDataCopy.ids.push(id)
		} else {
			filterDataCopy.ids = filterDataCopy.ids.filter(item => item !== id)
		}

		setFilterData(filterDataCopy)
	}

	function downloadExcelFile() {
		var excelHeaders = [[t('name2'), t('unit')]]
		for (let i = 0; i < data.poses.length; i++) {
			var pos = data.poses[i]
			excelHeaders[0].push(pos.short_name)
		}
		excelHeaders[0].push(t('total'))

		for (let i = 0; i < data.elements.length; i++) {
			var item = data.elements[i]
			var excelItems = []
			excelItems.push(item.name)
			excelItems.push(item.unit_name)
			for (let i = 0; i < item.poses.length; i++) {
				var item2 = item.poses[i];
				excelItems.push(Number(item2.income).toFixed(2))
			}
			excelItems.push(Number(item.total_income).toFixed(2))
			excelHeaders.push(excelItems)
		}

		const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
		XLSX.writeFile(wb, t('elements_incomes') + ".xlsx");
	}

	async function toggleModalCheques(bool = false, payload = {}) {
		setModalCheques(bool)

		if (bool) {
			var filterDataCopy = { ...filterData }
			var filterUrl = "/chain/element-incomes-documents"
			var urlParams = ""

			if (payload?.pos_id)
				urlParams += returnSign(urlParams) + 'pos_id=' + payload.pos_id
			if (payload?.element_id)
				urlParams += returnSign(urlParams) + 'element_id=' + payload.element_id
			if (filterDataCopy.start_date)
				urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
			if (filterDataCopy.end_date)
				urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date

			filterUrl = filterUrl + urlParams

			const response = await GET(filterUrl, {}, { loader: true })
			if (httpOk(response)) {
				setCheques(response.data)
			}
		} else {
			setCheques([])
		}
	}

	const handlePrint = useReactToPrint({
		content: () => printRef.current,
	});

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getSuppliers() {
		const response = await GET('/helper/suppliers', {}, { loader: true })
		if (httpOk(response)) setSuppliers(response.data)
	}

	useEffect(() => {
		getPoses()
		getSuppliers()
		dispatch(TOGGLE_LEFT_MENU(false))
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="d-flex gap-3">
				<div style={{ 'minWidth': '200px' }}>
					<div className="card mb-3" style={{ 'height': 'calc(100vh - 160px)', 'overflow': 'auto' }}>
						<div className="card-body">
							<h5 className="mb-3">{t('poses')}</h5>
							<div className="flex-column" style={{ 'height': 'calc(100vh - 270px)', 'overflow': 'auto' }}>
								<div className="form-check">
									<input id="all"
										className="form-check-input"
										type="checkbox"
										onChange={(e) => handleCheckboxChangeAll(e)}
									/>
									<label className="form-check-label" htmlFor="all">
										{t('all')}
									</label>
								</div>
								{poses?.map((item, index) => (
									<div className="form-check" key={index}>
										<input id={`pos${index}`} className="form-check-input" type="checkbox"
											checked={filterData?.ids?.includes(item.id)}
											onChange={(e) => handleCheckboxChange(e, item.id)}
										/>
										<label className="form-check-label" htmlFor={`pos${index}`}>
											{item.short_name}
										</label>
									</div>
								))}
							</div>
							<Dropdown>
								<Dropdown.Toggle variant="outline-primary w-100">
									{t('action')}
								</Dropdown.Toggle>

								<Dropdown.Menu>
									<div className="table-dropdown-item"
										onClick={handlePrint}>
										<i className="uil-print"></i>
										{t('print')}
									</div>
									<div className="table-dropdown-item"
										onClick={() => downloadExcelFile()}>
										<i className="uil uil-file-download-alt"></i>
										EXCEL
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					<div className="card">
						<div className="card-body">
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 w-100">
										{t('filter')}
									</Dropdown.Toggle>
									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('suppliers')}</label>
												<Select
													isClearable
													options={suppliers}
													value={suppliers.find(option => option.id === filterData.supplier_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'supplier_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter(filterData)}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>
				</div>

				<div className="w-100">
					<div className="card">
						<div className="card-body">
							<div className="table-responsive table-fixed"
								style={{ 'height': 'calc(100vh - 105px)', 'overflow': 'auto' }}>
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th style={{ 'width': '33px' }} className="text-center">#</th>
											<th style={{ 'width': '50%' }}>{t('name2')}</th>
											<th style={{ 'width': '5%' }} className="text-center td-ellipsis"
												title={t('unit')}>
												{t('unit')}
											</th>
											{data?.poses?.map((item, index) => (
												<th key={index} style={{ 'width': '2rem', 'height': '' }}>
													<div className="text-end">
														{item.short_name}
													</div>
												</th>
											))}
											<th className="text-nowrap text-end">
												{t('total')}
											</th>
										</tr>
									</thead>
									<tbody>
										{data?.elements?.map((item, index) => (
											<tr key={index}>
												<td className="text-center">{index + 1}</td>
												<td>{item.name}</td>
												<td className="text-center">{item.unit_name}</td>
												{item?.poses?.length &&
													<Fragment>
														{item.poses.map((item2, index2) => (
															<Fragment key={index2}>
																<td className="text-nowrap text-end hover"
																	onClick={() => toggleModalCheques(true, { 'pos_id': item2.id, 'element_id': item.id })}>
																	{formatMoney(item2.income, 2)}
																</td>
															</Fragment>
														))}
													</Fragment>
												}
												<td className="text-nowrap text-end">
													<b>{formatMoney(item.total_income, 2)}</b>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={modalCheques} animation={false} centered size="xl"
				dialogClassName="update-modal-width"
				onHide={() => toggleModalCheques(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('good_reception')} [{cheques?.length}]</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive" style={{ 'height': '500px', 'overflow': 'auto' }}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }} className="td-ellipsis">{t('pos')}</th>
									<th style={{ 'width': '15%' }} className="td-ellipsis">{t('supplier')}</th>
									<th style={{ 'width': '5%' }} className="text-center">{t('document')}</th>
									<th style={{ 'width': '45%' }}>{t('note')}</th>
									<th style={{ 'width': '10%' }} className="text-nowrap text-center">{t('date')}</th>
									<th style={{ 'width': '10%' }} className="text-nowrap text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{cheques?.map((item, index) => (
									<tr key={index}>
										<td className="text-center td-ellipsis">{index + 1}</td>
										<td className="td-ellipsis">{item.pos_name}</td>
										<td className="td-ellipsis">{item.supplier_name}</td>
										<td className="text-center">{item.document_number}</td>
										<td className="td-ellipsis">{item.note}</td>
										<td className="text-center">
											{formatDate(item.created_at, 'dd.MM.yy HH:mm')}
										</td>
										<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			<div id="print" className="d-none">
				<div className="w80mm" ref={printRef}>
					<table className="table table-bordered mb-0">
						<thead>
							<tr>
								<th style={{ 'width': '33px' }} className="text-center">#</th>
								<th style={{ 'width': '50%' }}>{t('name2')}</th>
								<th style={{ 'width': '15px' }} className="text-center td-ellipsis"
									title={t('unit')}>
									{t('unit')}
								</th>
								{data?.poses?.map((item, index) => (
									<th key={index} style={{ 'width': '2rem', 'height': '' }}>
										<div className="text-end">
											{item.short_name}
										</div>
									</th>
								))}
								<th className="text-nowrap text-end">
									{t('total')}
								</th>
							</tr>
						</thead>
						<tbody>
							{data?.elements?.map((item, index) => (
								<tr key={index}>
									<td className="text-center">{index + 1}</td>
									<td>{item.name}</td>
									<td className="text-center">{item.unit_name}</td>
									{item?.poses?.length &&
										<Fragment>
											{item.poses.map((item2, index2) => (
												<Fragment key={index2}>
													<td className="text-nowrap text-end hover">
														{formatMoney(item2.income, 2)}
													</td>
												</Fragment>
											))}
										</Fragment>
									}
									<td className="text-nowrap text-end">
										<b>{formatMoney(item.total_income, 2)}</b>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</>
	)
}

export default Index